import './DashboardChatSection.scss'
import React from "react";
import {Grid, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import ChatStore from "../../../../pages/chat-agent/ChatStore.ts";
import {observer} from "mobx-react-lite";
import {generatePath, useNavigate, useParams} from "react-router";
import {routes} from "../../../../routing/routes.ts";
import {useChatContext} from "../../../../pages/chat-agent/context/ChatContext.tsx";
import ChatConstants from "../../../../pages/chat-agent/ChatConstants.ts";

export const DashboardChatSection: React.FC = observer(() => {
    const {startNewChat, isWaiting} = useChatContext();
    const navigate = useNavigate();
    const params = useParams();
    const [inputValue, setInputValue] = React.useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const v = inputValue.trim();
        if (v) {
            setInputValue('')
            ChatStore.setUserInputValue(v)

            if (isWaiting) {
                // Do not send the message but simply bring the user to the chat
                ChatStore.setUserInputValue(v)
            } else {
                startNewChat(v)
                ChatStore.setUserInputValue('')
            }

            navigate(generatePath(routes.chat, params))
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) handleSubmit(e)
    }

    // const s = Boolean(currentSession?.messages.length)
    // const f = hasReceivedFinalMessage;

    return <Grid component="section" container justifyContent="center" className="dashboard-chat-section">
        <Grid size={{xl: 8, lg: 9, md: 12}}>
            <Typography className="title">
                {/*s={'' + s} | f={'' + f} | W={'' + isWaiting}*/}
                Ask questions, explore your spend, or request insights
            </Typography>

            <TextField
                className="chat-input-field"
                // inputRef={inputRef}
                slotProps={{
                    input: {
                        // startAdornment: (
                        //     <InputAdornment position="start">
                        //         <IconButton>
                        //             <Add/>
                        //         </IconButton>
                        //     </InputAdornment>
                        // ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={handleSubmit}>
                                    <ArrowForward/>
                                </IconButton>
                            </InputAdornment>
                        )
                    },
                }}
                variant="outlined"
                fullWidth
                multiline
                rows={3}

                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyPress}

                placeholder={`Ask ${ChatConstants.name} anything about your spend \u2026`}
                // disabled={disabled}
            />

        </Grid>
    </Grid>
})